
sap["ls"]["preload"]["UCF_LoadingPlaceHolder"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LoadingPlaceHolder(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["UCF_LoadingPlaceHolder"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) == "object", "typeof(oDomRef) == \"object\"", "LoadingPlaceHolder.js(20): UCF_LoadingPlaceHolder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LoadingPlaceHolder.js(21): UCF_LoadingPlaceHolder"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LoadingPlaceHolder.js(22): UCF_LoadingPlaceHolder"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["oLS"]["attachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
};window["UCF_LoadingPlaceHolder"] = UCF_LoadingPlaceHolder; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LoadingPlaceHolder"); UCF_LoadingPlaceHolder["_"] = {UCF_LoadingPlaceHolder: 0}; }; ;

UCF_LoadingPlaceHolder["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_LoadingPlaceHolder.prototype["sClassName"] = "UCF_LoadingPlaceHolder";


UCF_LoadingPlaceHolder["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["initialize"]++; }; 
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["initialize"] = 0; };

/**
 * Fires the Load event after the initializeIDs-Phase of startup/update
 */
UCF_LoadingPlaceHolder["prototype"]["onAfterControlsInitialized"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["onAfterControlsInitialized"]++; }; 
	// Additional delay to make sure ClientInspector.Notify events are contained in the event queue,
	// because it also is triggered by After-ControlsInitialized.
	UCF_JsUtil["delayedCall"](0, this, "fireLoad", [this["sId"]]);
	// Immediately detach: WDA might do an update with only script-calls and NOT remove the LoadingPlaceholder,
	// The initializeIDs array would be empty, but LS will still send the event!
	this["oLS"]["detachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["onAfterControlsInitialized"] = 0; };

UCF_LoadingPlaceHolder["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["destroy"]++; }; 
	UCF_JsUtil["clearDelayedCallsOfObject"](this);
	this["oLS"]["detachAfterEvent"](this["oLS"]["E_EVENTS"]["ControlsInitialized"], this, 'onAfterControlsInitialized');
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["destroy"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aAttributeNames"] = ["sId","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aEventNames"] = ["Load"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LoadingPlaceHolder["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {string}
 */
UCF_LoadingPlaceHolder["prototype"]["sId"] = '';

/**
 * @private
 * @type {string}
 */
UCF_LoadingPlaceHolder["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_LoadingPlaceHolder["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["setDefaultValues"]++; }; 
	this["sId"] = '';
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Id", '', true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId The Id of the control
 * @fires LoadingPlaceHolder::Load
 */
UCF_LoadingPlaceHolder["prototype"]["fireLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["fireLoad"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "LoadingPlaceHolder.js(108): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "LoadingPlaceHolder.js(109): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "LoadingPlaceHolder.js(110): fireLoad"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("LoadingPlaceHolder", "Load", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingPlaceHolder["_"]["fireLoad"] = 0; };

};